import * as Inovx from '@shared';
import UserConstants from '../constants/UserConstants';
import UserServices from '../services/UserServices';
import SettingsService from '../services/SettingsService';
import UserStore from '../stores/UserStore';

var SystemActions = Inovx.Shared.System.Actions;
var SystemStore = Inovx.Shared.System.Store;

declare var InovxLoader: any;

function receiveData(data: IUser[]) {
    Inovx.Shared.Flux.AppDispatcher.dispatch({
        actionType: UserConstants.USER_RECIEVE_DATA,
        data: data
    });
}

function receiveHint(data: IUser[], callback: any) {
    Inovx.Shared.Flux.AppDispatcher.dispatch({
        actionType: UserConstants.USER_RECIEVE_HINT,
        data: data,
        callback: callback
    });
}

function receiveCurrentUser(data: IUserDetails, callback: any) {
    Inovx.Shared.Flux.AppDispatcher.dispatch({
        actionType: UserConstants.USER_RECIEVE_CURRENT,
        data: data,
        callback: callback
    });
}

function _finishEdit() {
    Inovx.Shared.Flux.AppDispatcher.dispatch({
        actionType: UserConstants.FINISH_EDIT
    });
}

function _hideSettings() {
    Inovx.Shared.Flux.AppDispatcher.dispatch({
        actionType: UserConstants.HIDE_SETTINGS_MENU
    });
}

function sendInvalidSave() {
    Inovx.Shared.Flux.AppDispatcher.dispatch({
        actionType: UserConstants.USER_FORM_INVALID_SAVE
    });
}

function sendValidationError(comp: string, error: IErrorMessageObject) {
    Inovx.Shared.Flux.AppDispatcher.dispatch({
        actionType: UserConstants.USER_VALIDATION_ERROR,
        messageObj: error,
        component: comp
    });
}

function sendBeginEdit(user: IUserDetails, roles: IDefaultNamedItem[], entitlement: IDefaultNamedItem[]) {
    Inovx.Shared.Flux.AppDispatcher.dispatch({
        actionType: user ? UserConstants.BEGIN_EDIT_USER : UserConstants.BEGIN_USER_ADD,
        user: user,
        entitlement: entitlement,
        role: roles
    });
}

function getEntitlementList(cbFn: (data: IEntitlementGroup[]) => void, errorCbFn: (error: any) => void, ignoreDefault?: boolean) {
    UserServices.getEntitlements((entitlement: IEntitlementGroup[]) => {
        cbFn(entitlement);
    }, (error) => {
        errorCbFn(error);
    }, ignoreDefault);
}

function getRolesList(cbFn: (data: IRole[]) => void, errorCbFn: (error: any) => void, ignoreDefault?: boolean) {
    UserServices.getRoles((roles: IRole[]) => {
        cbFn(roles);
    }, (error) => {
        errorCbFn(error);
    }, ignoreDefault);
}

function getUserSystemSetting(cbFn: (data: IUserSystemSetting) => void, errorCbFn: (error: any) => void, ignoreDefault?: boolean) {
    SettingsService.getSystemSettings((setting: IUserSystemSetting) => {
        cbFn(setting);
    }, (error) => {
        errorCbFn(error);
    }, ignoreDefault);
}

var UserActions = {
    getAllUsers(callback: any, errorCallback: any, ignoreDefaultError?: boolean) {
        UserServices.getAll(function (data) {
            if (callback !== 'undefined' && callback != null) {
                callback();
            }
            receiveData(data);
        }, function (error) {
            if (errorCallback) {
                errorCallback(error);
            }
        }, ignoreDefaultError);
    },

    create(callback?: any) {
        if (UserStore.getIsValidObject(UserConstants.USER_ADD_FORM)) {
            if (!SystemStore.isActionInProgress(UserConstants.USER_ADD)) {
                SystemActions.beginAction(UserConstants.USER_ADD);

                UserServices.createUser(UserStore.getEditUser(),
                    function () {
                        UserActions.refreshData();
                        if (callback !== undefined && callback != null) {
                            callback();
                        }

                        _finishEdit();
                        SystemActions.endAction(UserConstants.USER_ADD);
                    },
                    function (error) {
                        if (error.messageObj.propertyName) {
                            sendValidationError(UserConstants.USER_ADD_FORM, error.messageObj);
                        }

                        SystemActions.endAction(UserConstants.USER_ADD);
                    },
                    function (error) {
                        return error.messageObj.propertyName ? true : false;
                    });
            }
        } else {
            sendInvalidSave();
        }
    },

    delete(user: IUser, callback: any) {
        if (!SystemStore.isActionInProgress(UserConstants.USER_DELETE)) {
            SystemActions.beginAction(UserConstants.USER_DELETE);

            UserServices.deleteUser(user,
                function () {
                    UserActions.refreshData();
                    if (callback !== undefined && callback != null) {
                        callback();
                    }

                    SystemActions.endAction(UserConstants.USER_DELETE);
                },
                function (error) {
                    SystemActions.endAction(UserConstants.USER_DELETE);
                });
        }
    },

    edit(callback?: any) {
        if (UserStore.getIsValidObject(UserConstants.USER_ADD_FORM)) {
            if (!SystemStore.isActionInProgress(UserConstants.USER_EDIT)) {
                SystemActions.beginAction(UserConstants.USER_EDIT);

                UserServices.editUser(UserStore.getEditUser(),
                    function () {
                        UserActions.refreshData();
                        if (callback !== undefined && callback != null) {
                            callback();
                        }

                        _finishEdit();
                        SystemActions.endAction(UserConstants.USER_EDIT);
                    },
                    function (error) {
                        if (error.messageObj.propertyName) {
                            if (error.messageObj.propertyName == "UserName" && error.messageObj.reason == 'DuplicateDeletedUserName') {
                                let messageObject: IErrorMessageObject = {
                                    message: InovxLoader.t("users:form.duplicateEmail"),
                                    reason: error.messageObj.reason,
                                    propertyName: "Email"
                                }
                                sendValidationError(UserConstants.USER_ADD_FORM, messageObject);
                            }
                            else
                                sendValidationError(UserConstants.USER_ADD_FORM, error.messageObj);
                        }

                        SystemActions.endAction(UserConstants.USER_EDIT);
                    },
                    function (error) {
                            return error.messageObj.propertyName ? true : false;
                    });
            }
        } else {
            sendInvalidSave();
        }
    },

    changePassword(user: IUser, password: string, callback: any, errorCallback: any) {
        if (!SystemStore.isActionInProgress(UserConstants.USER_CHANGE_PASSWORD)) {
            SystemActions.beginAction(UserConstants.USER_CHANGE_PASSWORD);

            UserServices.changePassword(user, password,
                function (updatedUser : any) {

                    Inovx.Shared.Flux.AppDispatcher.dispatch({
                        actionType: UserConstants.USER_CHANGE_PASSWORD_SUCCESS,
                        user: updatedUser
                    });

                    callback();

                    SystemActions.endAction(UserConstants.USER_CHANGE_PASSWORD);
                },
                function (error) {
                    errorCallback(error);

                    SystemActions.endAction(UserConstants.USER_CHANGE_PASSWORD);
                },
                function (error) {
                    return error.messageObj.propertyName ? true : false;
                });
        }
    },

    resetPasswords(callback?: any, errorCallback?: any) {

        UserServices.resetPasswords(
            function () {
                if (callback) {
                    callback();
                }
            },
            function (error) {
                if (errorCallback) {
                    errorCallback(error);
                }
            },
            true);
    },

    beginAdd() {
        if (!SystemStore.isActionInProgress(UserConstants.BEGIN_USER_ADD)) {
            SystemActions.beginAction(UserConstants.BEGIN_USER_ADD);
            let entitlement: IDefaultNamedItem[] = [];
            let roles: IDefaultNamedItem[] = [];

            let getRolesCall = () => {
                getRolesList((roleData) => {
                    roles = roleData;
                    sendBeginEdit(null, roles, entitlement);

                    SystemActions.endAction(UserConstants.BEGIN_USER_ADD);
                }, (error) => {
                    sendBeginEdit(null, roles, entitlement);

                    SystemActions.endAction(UserConstants.BEGIN_USER_ADD);
                }, true);
            };

            getEntitlementList((entitlementData) => {
                entitlement = entitlementData;

                getRolesCall();
            }, (error: any) => {
                getRolesCall();
            }, true);
        }
    },

    beginEdit(user: IUser) {
        if (!SystemStore.isActionInProgress(UserConstants.BEGIN_EDIT_USER)) {
            SystemActions.beginAction(UserConstants.BEGIN_EDIT_USER);

            UserServices.getDetail(user.UserID,
                function (data) {
                    if (!data.EntitlementGroupIDs) data.EntitlementGroupIDs = [];
                    if (!data.RoleIDs) data.RoleIDs = [];

                    let entitlement: IDefaultNamedItem[] = [];
                    let roles: IDefaultNamedItem[] = [];

                    let getRolesCall = () => {
                        getRolesList((roleData) => {
                            roles = roleData;
                            sendBeginEdit(data, roles, entitlement);

                            SystemActions.endAction(UserConstants.BEGIN_EDIT_USER);
                        }, (error) => {
                            sendBeginEdit(data, roles, entitlement);

                            SystemActions.endAction(UserConstants.BEGIN_EDIT_USER);
                        }, true);
                    };

                    getEntitlementList((entitlementData) => {
                        entitlement = entitlementData;

                        getRolesCall();
                    }, (error: any) => {
                        getRolesCall();
                    }, true);
                },
                function (error) {
                    SystemActions.endAction(UserConstants.BEGIN_EDIT_USER);
                });
        }
    },

    selectHint(user: IUser) {
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: UserConstants.USER_SELECT_HINT,
            user: user
        });
    },

    finishEdit() {
        if (UserStore.getHasChanges()) {
            var callbackFunct = UserActions.create;
            if (UserStore.getIsEditing()) {
                callbackFunct = UserActions.edit;
            }
            SystemActions.displaySaveChangesDialog({
                message: InovxLoader.t("common:msgBox.saveChanges"),
                confirmCallback: callbackFunct,
                cancelCallback: _finishEdit
            });
        } else {
            _finishEdit();
        }
    },

    refreshData() {
        this.getAllUsers();
    },


    getHint(hint: string, callback: any) {
        if (!SystemStore.isActionInProgress(UserConstants.USER_CHECK_NAME)) {
            SystemActions.beginAction(UserConstants.USER_CHECK_NAME);

            UserServices.checkName(hint,
                function (data) {
                    receiveHint(data, callback);
                    SystemActions.endAction(UserConstants.USER_CHECK_NAME);
                },
                function (error) {
                    SystemActions.endAction(UserConstants.USER_CHECK_NAME);
                });
        }
    },

    getCurrentUser(callback: any) {
        if (!SystemStore.isActionInProgress(UserConstants.USER_CURRENT_GET)) {
            SystemActions.beginAction(UserConstants.USER_CURRENT_GET);

            UserServices.getCurrentUserDetail(
                function (data) {
                    receiveCurrentUser(data, callback);
                    SystemActions.endAction(UserConstants.USER_CURRENT_GET);
                },
                function (error) {
                    SystemActions.endAction(UserConstants.USER_CURRENT_GET);
                });
        }
    },

    resetLoginAttempts(user: IUser, callback?: any) {
        if (!SystemStore.isActionInProgress(UserConstants.RESET_LOGIN_ATTEMPTS)) {
            SystemActions.beginAction(UserConstants.RESET_LOGIN_ATTEMPTS);

            UserServices.resetLoginAttempts(user,
                function () {
                    UserServices.getDetail(user.UserID,
                        function (data) {
                            Inovx.Shared.Flux.AppDispatcher.dispatch({
                                actionType: UserConstants.RESET_LOGIN_ATTEMPTS,
                                user: data
                            });

                            if (callback) {
                                callback();
                            }

                            SystemActions.endAction(UserConstants.RESET_LOGIN_ATTEMPTS);
                        },
                        function (error) {
                            SystemActions.endAction(UserConstants.RESET_LOGIN_ATTEMPTS);
                        }
                    );
            },
            function (error) {
                SystemActions.endAction(UserConstants.RESET_LOGIN_ATTEMPTS);
            });

        }
    },

    editCurrentObject(comp: string, key: string, value: any) {
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: UserConstants.USER_UPDATE_OBJECT,
            component: comp,
            key: key,
            value: value
        });
    },

    editCurrentObjectAddToList(comp: string, key: string, value: any) {
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: UserConstants.USER_UPDATE_OBJECT_ADD_LIST,
            component: comp,
            key: key,
            value: value
        });
    },

    editCurrentObjectRemoveFromList(comp: string, key: string, value: any) {
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: UserConstants.USER_UPDATE_OBJECT_REMOVE_LIST,
            component: comp,
            key: key,
            value: value
        });
    },

    hideSettings() {
        if (UserStore.getHasChanges()) {
            SystemActions.displaySaveChangesDialog({
                message: InovxLoader.t("common:msgBox.saveChanges"),
                confirmCallback: UserActions.saveSettings,
                cancelCallback: _hideSettings
            });
        } else {
            _hideSettings();
        }
    },

    saveSettings(errorCallback?: any, ignoreVSuiteLoginError?: boolean) {
        if (UserStore.getIsValidObject(UserConstants.USER_SETTINGS_FORM)) {
            if (!SystemStore.isActionInProgress(UserConstants.SETTINGS_SAVE))
            {
                SystemActions.beginAction(UserConstants.SETTINGS_SAVE);
                SettingsService.saveSettings(
                    UserStore.getSaveFriendlyEditSettings(),
                    function ()
                    {
                        _hideSettings();

                        Inovx.Shared.Flux.AppDispatcher.dispatch({
                            actionType: UserConstants.SETTINGS_GET,
                            data: { ...UserStore.getSaveFriendlyEditSettings() },
                            display: UserStore.getSettingsShown()
                        });

                        SystemActions.endAction(UserConstants.SETTINGS_SAVE);
                    },
                    function (error)
                    {
                        if (errorCallback) {
                            errorCallback(error);
                        }
                        SystemActions.endAction(UserConstants.SETTINGS_SAVE);
                    },
                    ignoreVSuiteLoginError
                )
            }
        } else {
            sendInvalidSave();
        }
    },

    getSettings(displaySettings: boolean, callback?: any, errorCallback?: any) {

        if (!SystemStore.isActionInProgress(UserConstants.SETTINGS_GET)) {
            SystemActions.beginAction(UserConstants.SETTINGS_GET);

            SettingsService.getSettings(function (data) {
                Inovx.Shared.Flux.AppDispatcher.dispatch({
                    actionType: UserConstants.SETTINGS_GET,
                    data: data,
                    display: displaySettings
                });

                if (callback) {
                    callback();
                }

                SystemActions.endAction(UserConstants.SETTINGS_GET);
            }, function (error) {
                if (errorCallback) {
                    errorCallback(error);
                }
                SystemActions.endAction(UserConstants.SETTINGS_GET);
            });
        }
    },

    getUserSystemPreferences(callback: any, errorCallback?: any) {
        let entitlement: IEntitlementGroup[] = [];
        let roles: IRole[] = [];
        let defaultSetting: IUserSystemSetting;

        if (!SystemStore.isActionInProgress(UserConstants.SYSTEM_SETTINGS_GET)) {
            SystemActions.beginAction(UserConstants.SYSTEM_SETTINGS_GET);
            getUserSystemSetting((settingData) => {
                defaultSetting = settingData;
                getRolesList((roleData) => {
                    roles = roleData;
                    getEntitlementList((entitlementData) => {
                        entitlement = entitlementData;
                        var data: IUserSystemPreferences = {
                            DefaultSytemSetting: defaultSetting,
                            AllGroups: entitlement,
                            AllRoles: roles
                        }
                        callback(data);
                        SystemActions.endAction(UserConstants.SYSTEM_SETTINGS_GET);
                    }, (error) => {
                        if (errorCallback) {
                            errorCallback(error);
                        }
                        SystemActions.endAction(UserConstants.SYSTEM_SETTINGS_GET);
                    }, true);
                }, (error) => {
                    if (errorCallback) {
                        errorCallback(error);
                    }
                    SystemActions.endAction(UserConstants.SYSTEM_SETTINGS_GET);
                }, true);

            }, (error) => {
                if (errorCallback) {
                    errorCallback(error);
                }
                SystemActions.endAction(UserConstants.SYSTEM_SETTINGS_GET);
            }, true);
        }

    },

    saveSystemSettings(systemSetting: any, callback:any, errorCallback?: any) {
        if (!SystemStore.isActionInProgress(UserConstants.SYSTEM_SETTINGS_SAVE)) {
            SystemActions.beginAction(UserConstants.SYSTEM_SETTINGS_SAVE);
            SettingsService.saveSystemSettings(
                systemSetting,
                function () {
                    if (callback !== undefined) {
                        callback();
                    }
                    SystemActions.endAction(UserConstants.SYSTEM_SETTINGS_SAVE);
                },
                function (error) {
                    if (errorCallback) {
                        errorCallback(error);
                    }
                    SystemActions.endAction(UserConstants.SYSTEM_SETTINGS_SAVE);
                },
            )
        }
    },

    getLinkedEntitlementGroups(id: string): Promise<string[]> {
        return new Promise((resolve, reject) => {
            UserServices.getLinkedEntitlementGroups(id, (data) => resolve(data), (error) => reject(error));
        });
    },

    getLinkedRoles(id: string): Promise<string[]> {
        return new Promise((resolve, reject) => {
            UserServices.getLinkedRoles(id, (data) => resolve(data), (error) => reject(error));
        });
    },

    synchronizeLinkedGroups(callback: any, errorCallback: (error: IServiceErrorObject) => void, ignoreDefaultError?: boolean) {
        return UserServices.synchronizeLinkedGroups(
            function () {
                if (callback !== undefined) {
                    callback();
                }
            }, function (error) {
                if (errorCallback) {
                    errorCallback(error);
                }
            }, ignoreDefaultError);
    },

}

export default UserActions;
